(function($) {

    /*
    |--------------------------------------------------------------------------
    | Drop Cookie
    |--------------------------------------------------------------------------
    |
    | Function to drop the cookie with a boolean value of true.
    |
    */
    var dropCookie = function(value, expiryDays) {
        setCookie('carregarPopup', value, expiryDays);
    };

    /*
    |--------------------------------------------------------------------------
    | Set Cookie
    |--------------------------------------------------------------------------
    |
    | Sets cookie with 'name' and value of 'value' for 'expiry_days'.
    |
    */
    var setCookie = function(name, value, expiry) {
        var d = new Date();
        //d.setTime(d.getTime() + (expiry*24*60*60*1000));
        d.setTime(d.getTime() + (expiry*60*1000)); // Calcula el tiempo de expiración en milisegundos
        var expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
        return getCookie(name);
    };

    /*
    |--------------------------------------------------------------------------
    | Get Cookie
    |--------------------------------------------------------------------------
    |
    | Gets cookie called 'name'.
    |
    */
    var getCookie = function(name) {
        var cookie_name = name + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(cookie_name) === 0) {
                return c.substring(cookie_name.length, c.length);
            }
        }
        return false;
    };


$(document).ready(function() {


        // Comprovem que existeix l'objecte global i els camps
    if (
        !window.VACANCES ||
        !window.VACANCES.inici ||
        !window.VACANCES.fi ||
        !window.VACANCES.missatge
    ) {
        return; // no fem res si falta informació
    }


    function parseData(data) {
        var parts = data.split('/');
        return new Date(parts[2], parts[1] - 1, parts[0]);
    }

    var ara = new Date();
    // Llegim des del global window
    var vacances_inici = parseData(window.VACANCES.inici);
    var vacances_fi = parseData(window.VACANCES.fi);
    var missatge = window.VACANCES.missatge;

    // Fixem l'hora final a les 23:59:59 per incloure tot el dia
    vacances_fi.setHours(23, 59, 59, 999);

    if (ara >= vacances_inici && ara <= vacances_fi) {

        var carregarPopupcookie = getCookie('carregarPopup');

        if (!carregarPopupcookie) {


            $.magnificPopup.open({
                items: {
                    src: '<div class="popup"><h1 class="text-center">Avís!</h1><p>' + missatge + '</p></div>'
                },
                midClick: true,
                closeOnBgClick: false,
                type: 'inline'
            }, 0);

            setCookie('carregarPopup', true, 15);
        }
    }
});

}(jQuery));
